export const APP_VERSION_HEADER = `X-version-EzTenda-${
  process.env.NEXT_PUBLIC_NODE_ENV || 'environment'
}`
